import React, { useState, useEffect, useContext } from 'react';
import MasterPage from '@components/MasterPage';
import ListTemplate from './components/ListTemplate';
import Button from '@components/Button';
import {IProps, IState} from './types';
import * as S from './styles';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import selectors from '@state/selectors';
import { openNewTemplateAction, reloadListAction } from '@state/openReducers/actions';
import { IAppState } from '@state/types';
import { setParams } from '@utils/userUtils';
import WarningScreen from '@components/WarningScreen';
import C from '@assets/themes/colors';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import { TemplatesProvider } from '@utils/DOIgnition/TemplatesContext';
import { IUserType } from '@state/auth/types';

const Templates:React.FC<IProps> = (props) => {
    const authContext = useContext(AuthContext);
    const hasPermissions = authContext.userData && authContext.userData.profile && (authContext.userData.profile.role === IUserType.ADMIN || (authContext.userData.profile.role === IUserType.DEALER_USER && authContext.dsPermissions?.includes("TEMPLATE_MANAGEMENT")));

    const openNewTemplateState = useSelector<IAppState, IAppState["openNewTemplateState"]>((state) => state.openNewTemplateState).openNewTemplate;
    const templates = useSelector(selectors.templates.getTemplates);

    const dispatch = useDispatch();
    const history = useHistory();

    const [open, setOpen] = useState(false);
    const [warningOptions, setWarningOptions] = useState({
      title: '',
      subtitle: '',
      actionTitle: '',
      actionFunction: () => {},
      closeActionTitle: '',
      errorNote: '',
      errorArguments: [],
    });
    const [noAdminDetected, setNoAdminDetected] = useState(false);

    useEffect(() => {
      if (!hasPermissions) {
        handleWarningScreen(
          true, "Unauthorized Page",
          `Please try to access Design Studio from a valid link in accordance with your user permissions. `,
          "", () => {history.push({pathname: '/'})}, "OKAY", "Unauthorized Page", []
        );
        setNoAdminDetected(true);
      }
    }, [])

    useEffect(() => {
      if (open === false && noAdminDetected === true) history.push({pathname: '/'});
    }, [open])

    const handleWarningScreen = (openValue:boolean, title:string, subtitle:string, actionTitle:string, actionFunction:any, closeActionTitle:string, errorNote:string, errorArguments: any) => {
      setOpen(openValue);
      setWarningOptions({
        title: title,
        subtitle: subtitle,
        actionTitle: actionTitle,
        actionFunction: actionFunction,
        closeActionTitle: closeActionTitle,
        errorNote: errorNote,
        errorArguments: errorArguments,
      })
    }

    const handleOpenNewTemplate = () => {
      dispatch(reloadListAction(false));
      dispatch(openNewTemplateAction(true));
      const url = setParams({ page: "new-template" });
      history.push(`?${url}`);
    }

    return (
      <S.Root>
        <WarningScreen
          open={open}
          setOpen={setOpen}
          options={warningOptions}
        />
        <MasterPage
            pageIndex={3}
            newHeight={300}
            renderAction={() => (
                <S.Header>
                  {
                    !openNewTemplateState &&
                    <Button
                        icon="add" 
                        label="NEW TEMPLATE"
                        style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 153, height: 36, boxSizing: 'border-box'}}
                        labelStyle={{color: "white", fontWeight: '500'}}
                        onClick={handleOpenNewTemplate}
                    />
                  }
                </S.Header>
            )}
        >
          {
            hasPermissions &&
            <TemplatesProvider hasDesigns={false} location='templates'>
                <ListTemplate
                  handleWarningScreen={handleWarningScreen}
                  openModal={open}
                />
            </TemplatesProvider>
          }
        </MasterPage>
      </S.Root>
    );
}

export default Templates;